/**
 * The enum values here should match the corresponsing key from i18n translation file
 */
export enum Calander {
    MY_SCHEDULE = 'mySchedule',
}